/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_Sent_Unsettled_HintInputs */

const vi_pos_einvoice_auto_sent_unsettled_hint = /** @type {(inputs: Pos_Einvoice_Auto_Sent_Unsettled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không phát hành lại đơn này. Hệ thống tự đối soát với MISA; xem trạng thái ngay bên dưới hoặc bấm Làm mới trạng thái.`)
};

/**

* @param {Pos_Einvoice_Auto_Sent_Unsettled_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_sent_unsettled_hint = /** @type {((inputs?: Pos_Einvoice_Auto_Sent_Unsettled_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_Sent_Unsettled_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_sent_unsettled_hint(inputs)
});